<template>
  <div>
    <div v-if="notfound">
      <img
        src="../../../assets/images/not_found.jpg"
        alt=""
      />
    </div>

    <div v-else>
      <div style="padding: 15px; display: flex; align-items: center;">
        <v-btn flat text @click="$router ? $router.back() : window.history.back()" style="padding: 3px; width: 90px; flex-shrink: 0;">
          <v-icon left color="darken-2">arrow_back</v-icon>Back
        </v-btn>
        <p style="font-size: 28px; text-align: center; margin: 0; flex-grow: 1;">
          ORDER NO. &nbsp;{{ detailData.theOrderID }}
        </p>
      </div>
      <div>
        <div class="col-12 col-xs-12 col-sm-6 col-md-3">
          <h5>
            Order Date: <span style="font-size: 14px">{{ detailData.created_at | moment('YYYY-MM-DD H:mm:ss') }}</span>
          </h5>
        </div>
        <div class="col-12 col-xs-12 col-sm-6 col-md-3">
          <h5>
            Confirm Date: <span style="font-size: 14px">{{ detailData.confirm_date }}</span>
          </h5>
        </div>
        <div class="col-12 col-xs-12 col-sm-6 col-md-3">
          <h5>
            Warehouse Date: <span style="font-size: 14px">{{ detailData.warehouse_date }}</span>
          </h5>
        </div>
        <div class="col-12 col-xs-12 col-sm-6 col-md-3 ">
          <h5>
            Expected Date: <span style="font-size: 14px">{{ detailData.from_date }} - {{ detailData.to_date }}</span>
          </h5>
        </div>
      </div>
      <div
        class="theStepper"
        style="padding-top: 5%; padding-bottom: 2%;box-shadow: 0 3px 1px -2px rgba(0, 0, 0, .2), 0 2px 2px 0 rgba(0, 0, 0, .14), 0 1px 5px 0 rgba(0, 0, 0, .12);"
      >
        <v-stepper
          alt-labels
          v-model="currentStep"
          vertical
          class="elevation-0 custom-stepper"
        >
          <v-stepper-header>
            <v-stepper-step :complete="currentStep >= 0" step="0" class="hover-steps-container">
              <!-- <template v-slot:icon>
                <img src="../../../assets/images/Waiting.gif" alt="Step 1" style="width: 24px; height: 24px;">
              </template> -->
              Requested
            <view-steps-dates :date="detailData.order_date" />
            </v-stepper-step>
            <v-divider class="divider"></v-divider>

            <v-stepper-step
              v-if="isCanceled && currentStep == 1"
              :rules="[() => false]"
              step="1"
              class="hover-steps-container"
            >
              Canceled
              <view-steps-dates :date="detailData.cancel_date" />
            </v-stepper-step>
            <v-divider
              class="divider"
              v-if="isCanceled && currentStep == 1"
            ></v-divider>

            <v-stepper-step :complete="currentStep >= 2" step="2" class="hover-steps-container">
              <!-- <template v-slot:icon> -->
                <!-- <img src="../../../assets/images/Processed.gif" alt="Step 1" style="width: 24px; height: 24px;"> -->
              <!-- </template> -->
              Processed
              <view-steps-dates v-if="detailData.process_date" :date="detailData.process_date" />
            </v-stepper-step>
            <v-divider class="divider"></v-divider>

            <v-stepper-step
              v-if="isCanceled && currentStep == 3"
              :rules="[() => false]"
              step="3"
              class="hover-steps-container"
            >
              Canceled
              <view-steps-dates v-if="detailData.cancel_date" :date="detailData.cancel_date" />
            </v-stepper-step>
            <v-divider
              class="divider"
              v-if="isCanceled && currentStep == 3"
            ></v-divider>

            <v-stepper-step :complete="currentStep >= 4" step="4" class="hover-steps-container">
              Approved
            <view-steps-dates v-if="detailData.confirm_date" :date="detailData.confirm_date" /></v-stepper-step>
            <v-divider class="divider"></v-divider>

            <v-stepper-step
              v-if="isRefunded && currentStep == 5"
              :rules="[() => false]"
              step="5"
              class="hover-steps-container"
            >
              Refunded
              <view-steps-dates v-if="detailData.refund_date" :date="detailData.refund_date" />
            </v-stepper-step>
            <v-divider
              class="divider"
              v-if="isRefunded"
            ></v-divider>

            <v-stepper-step :complete="currentStep >= 6" step="6" class="hover-steps-container">
              Purchased
              <view-steps-dates v-if="detailData.purchase_date" :date="detailData.purchase_date" />
            </v-stepper-step>
            <v-divider class="divider"></v-divider>

            <v-stepper-step :complete="currentStep >= 7" step="7" class="hover-steps-container">
              Warehouse Delivered
              <view-steps-dates v-if="detailData.warehouse_deliver_date" :date="detailData.warehouse_deliver_date" />
            </v-stepper-step>
            <v-divider class="divider"></v-divider>

            <v-stepper-step :complete="currentStep >= 8 || currentStep >= 9" step="8" class="hover-steps-container">
              Int. Shipping
              <view-steps-dates v-if="detailData.int_shipment_date" :date="detailData.int_shipment_date" />
            </v-stepper-step>
            <v-divider class="divider"></v-divider>

            <v-stepper-step :complete="currentStep >= 10" step="10" class="hover-steps-container">
              Delivered to Erbil
              <view-steps-dates v-if="detailData.branch_delivery_date" :date="detailData.branch_delivery_date" />
            </v-stepper-step>
            <v-divider class="divider"></v-divider>

            <v-stepper-step :complete="currentStep == 11" step="11" class="hover-steps-container">
              Delivered
              <view-steps-dates v-if="detailData.deliver_date" :date="detailData.deliver_date" />
            </v-stepper-step>
          </v-stepper-header>
        </v-stepper>
      </div>

      <div
        class="d-inline-block"
        style="margin-left: 25%"
      >
        <div
          class="d-inline mx-3"
          style="vertical-align: bottom"
        >
          <a
            @click="approvingOrder(detailData.order_id)"
            tooltip="Approve this order"
            :class="currentStep == 2 ? '' : 'disabled'"
          >
            <i
              class="fa fa-check-circle"
              :style="currentStep == 2 ? 'color: green; font-size:36px; ' : 'color: grey; font-size:36px; '"
            />
          </a>
        </div>

        <div
          class="d-inline mx-3"
          style="vertical-align: bottom"
        >
          <a
            @click="cancelOrderModal = true"
            tooltip="Cancel this order"
            :class="currentStep == 0 || currentStep == 2 ? '' : 'disabled'"
          >
            <i
              class="fa fa-times-circle"
              :style="
            currentStep == 0 || currentStep == 2
              ? 'color:red; font-size:36px; '
              : 'color:grey; font-size:36px;'
          "
            />
          </a>
        </div>

        <!-- hide until the functionlity is added
        <div
          v-if="detailData.status == 'delivered' && !detailData.order_delivery"
          class="d-inline mx-3"
        >
          <v-btn
            color="blue--text"
            style="height: auto;"
            depressed
            @click="requestDelivery()"
          >
            Request Delivery
          </v-btn>
        </div> -->

        <div
          v-if="detailData.status == 'delivered' && detailData.order_delivery && detailData.order_delivery.order_delivery_id"
          class="d-inline mx-3 white--text py-2 px-3"
          :class="{
            'blue lighten-1': detailData.order_delivery.status == 3,
            'green lighten-1': detailData.order_delivery.status == 4,
          }"
          style="border-radius: 6px; vertical-align: super"
        >
          Delivery {{ detailData.order_delivery.status_name }}
        </div>
      </div>

      <div
        class="row mx-0 mt-3 col-md-12"
        style="display: flex; width: 99%; border: 1px solid #dbd8d8; margin: 10px !important; border-radius: 8px; justify-content: center; flex-wrap: wrap; padding: 10px;"
        v-if="(detailData.images && detailData.images.length > 0) || detailData.image"
      >
        <div
          v-if="detailData.image"
          style="cursor: pointer; margin: 8px; width: 150px;"
          @click="showImage(detailData.image, true)"
        >
          <img
            :src="detailData.image && detailData.image.startsWith('http') ? detailData.image : `${$_image_path()}${detailData.image}`"
            alt="Image"
            width="100%"
            height="150px"
            style="border-radius: 4px; object-fit: cover;"
          >
        </div>
        <div
          v-for="(img,i) in detailData.images"
          :key="i"
          style="cursor: pointer; margin: 8px; width: 150px;"
          @click="showImage(img)"
        >
          <img
            :src="img.order_image && img.order_image.startsWith('http') ? img.order_image : `${$_image_path()}${img.order_image}`"
            alt="Image"
            width="100%"
            height="150px"
            style="border-radius: 4px; object-fit: cover;"
            class="thumbnail"
          >
        </div>
      </div>

      <div class="col-md-12" style="display: flex; justify-content: center;">
      <div
        class="col-md-12"
        v-if="detailData.cancel_reason != null"
        style="background: #FEE2E2; color: #000000FF; border: 1px solid #EF4444; border-radius: 4px; padding: 16px; margin: 20px 0; display: flex; align-items: center;"
      >
        <v-icon left style="color: #EF4444;margin-right: 8px;">warning</v-icon>
        <div>
          <strong>Order Canceled:</strong>
          <span>{{ detailData.cancel_reason }}</span>
        </div>
      </div>
    </div>

      <table id="detailTable">
        <tr v-if="detailData.refund_reason != null">
          <td class="price-section">
            <h6><b>Refund reason</b></h6>
          </td>
          <td class="price-section1">
            <h6>{{ detailData.refund_reason }}</h6>
          </td>
        </tr>
        <tr v-if="detailData.customer_process_note">
          <td class="price-section">
            <h6><b>Process Note</b></h6>
          </td>
          <td class="price-section1">
            <h6>{{ detailData.customer_process_note }}</h6>
          </td>
        </tr>
        <tr v-if="detailData.customer_process_note_image">
          <td class="price-section">
            <h6><b>Process Note Image</b></h6>
          </td>
          <td class="price-section1">
            <div
              style="cursor: pointer; margin: 8px; width: 150px;"
              @click="showImage(detailData.customer_process_note_image, true)"
            >
              <img
                :src="`${$_image_path()}${detailData.customer_process_note_image}`"
                alt="Image"
                width="100%"
                height="150px"
                style="border-radius: 4px; object-fit: cover;"
                class="thumbnail"
              >
            </div>
          </td>
        </tr>
        <tr>
          <td class="price-section">
            <h6><b>Product Name</b></h6>
          </td>
          <td class="price-section1">
            <h6>{{ detailData.product_name }}</h6>
          </td>
        </tr>
        <tr v-if="detailData.is_ship_only === '1'">
          <td class="price-section">
            <h6><b>Track No</b></h6>
          </td>
          <td class="price-section1">
            <h6>{{ detailData.track_number }}</h6>
          </td>
        </tr>
        <tr>
          <td class="price-section">
            <h6><b>Product URL</b></h6>
          </td>
          <td class="price-section1">
            <h6><a
                :href="detailData.product_url"
                target="_blank"
              >Link</a></h6>
          </td>
        </tr>
        <tr v-if="detailData.coupon != null">
          <td class="price-section">
            <h6><b>Coupon</b></h6>
          </td>
          <td class="price-section1">
            <h6>{{ detailData.coupon }}</h6>
          </td>
        </tr>
        <tr v-if="detailData.coupon != null">
          <td class="price-section">
            <h6><b>Coupon percentage</b></h6>
          </td>
          <td class="price-section1">
            <h6>{{ detailData.percentage }}%</h6>
          </td>
        </tr>
        <tr v-if="detailData.type != null">
          <td class="price-section">
            <h6><b>Type</b></h6>
          </td>
          <td class="price-section1">
            <h6>{{ detailData.type }}</h6>
          </td>
        </tr>
        <tr v-if="detailData.color != null">
          <td class="price-section">
            <h6><b>Color</b></h6>
          </td>
          <td class="price-section1">
            <h6>{{ detailData.color }}</h6>
          </td>
        </tr>
        <tr v-if="detailData.note != null">
          <td class="price-section">
            <h6><b>Note</b></h6>
          </td>
          <td class="price-section1">
            <h6>{{ detailData.note }}</h6>
          </td>
        </tr>
        <tr v-if="detailData.size != null">
          <td class="price-section">
            <h6><b>Size</b></h6>
          </td>
          <td class="price-section1">
            <h6>{{ detailData.size }}</h6>
          </td>
        </tr>
        <tr>
          <td class="price-section">
            <h6><b>Delivery type</b></h6>
          </td>
          <td class="price-section1">
            <h6>{{ detailData.delivery_type }}</h6>
          </td>
        </tr>
        <tr>
          <td class="price-section">
            <h6><b>Transportation type</b></h6>
          </td>
          <td class="price-section1">
            <h6>{{ detailData.transportation_type_obj ? detailData.transportation_type_obj.name : '' }}</h6>
          </td>
        </tr>
        <tr>
          <td class="price-section">
            <h6><b>Repackage</b></h6>
          </td>
          <td class="price-section1">
            <h6>{{ detailData.is_repackage ? 'Yes' : 'No' }}</h6>
          </td>
        </tr>
        <tr>
          <td class="price-section">
            <h6><b>Hold</b></h6>
          </td>
          <td class="price-section1">
            <h6>{{ detailData.is_hold ? 'Yes' : 'No' }}</h6>
          </td>
        </tr>
        <tr>
          <td class="price-section">
            <h6><b>Other Service</b></h6>
          </td>
          <td class="price-section1">
            <h6>{{ detailData.other_service }}</h6>
          </td>
        </tr>
        <tr>
          <td class="price-section">
            <h6><b>Quantity</b></h6>
          </td>
          <td class="price-section1">
            <h6>{{ detailData.quantity }}</h6>
          </td>
        </tr>
        <tr v-if="detailData.item_price != null">
          <td class="price-section">
            <h6><b>Quantity charge</b></h6>
          </td>
          <td class="price-section1">
            <h6>${{ detailData.quantity_charge }}</h6>
          </td>
        </tr>
        <tr v-if="detailData.item_price != null">
          <td class="price-section">
            <h6><b>Item price</b></h6>
          </td>
          <td class="price-section1">
            <h6>${{ detailData.item_price }}</h6>
          </td>
        </tr>
        <tr v-if="detailData.tax != null">
          <td class="price-section">
            <h6><b>Tax</b></h6>
          </td>
          <td class="price-section1">
            <h6>${{ detailData.tax }}</h6>
          </td>
        </tr>
        <tr v-if="detailData.national_tax != null">
          <td class="price-section">
            <h6><b>International Tax</b></h6>
          </td>
          <td class="price-section1">
            <h6>${{ detailData.national_tax }}</h6>
          </td>
        </tr>
        <tr v-if="detailData.item_weight != null">
          <td class="price-section">
            <h6><b>Item weight(LB)</b></h6>
          </td>
          <td class="price-section1">
            <h6>{{ (Number(detailData.item_weight) / 0.453592).toFixed(2) }}</h6>
          </td>
        </tr>
        <tr v-if="detailData.item_type != null">
          <td class="price-section">
            <h6><b>Item type</b></h6>
          </td>
          <td class="price-section1">
            <h6>{{ detailData.item_type }}</h6>
          </td>
        </tr>
        <tr v-if="detailData.coupon == null && detailData.internal_shipping_handling != null">
          <td class="price-section">
            <h6><b>Shipping Price</b></h6>
          </td>
          <td class="price-section1">
            <h6>${{ detailData.internal_shipping_handling }}</h6>
          </td>
        </tr>
        <tr v-if="detailData.coupon != null && detailData.tmp_shipping != null">
          <td class="price-section">
            <h6><b>Shipping Price</b></h6>
          </td>
          <td class="price-section1">
            <h6>${{ detailData.tmp_shipping }}</h6>
          </td>
        </tr>
        <tr v-if="detailData.coupon != null && detailData.tmp_shipping != null">
          <td class="price-section">
            <h6><b>Discounted Shipping Price</b></h6>
          </td>
          <td class="price-section1">
            <h6>${{ detailData.internal_shipping_handling }}</h6>
          </td>
        </tr>
        <tr v-if="detailData.delivery_price != null">
          <td class="price-section">
            <h6><b>Delivery price</b></h6>
          </td>
          <td class="price-section1">
            <h6>${{ detailData.delivery_price }}</h6>
          </td>
        </tr>
        <tr v-if="detailData.local_delivery != null">
          <td class="price-section">
            <h6><b>Local Delivery</b></h6>
          </td>
          <td class="price-section1">
            <h6>${{ detailData.local_delivery }}</h6>
          </td>
        </tr>
        <tr v-if="detailData.kreenex_fee != null">
          <td class="price-section">
            <h6><b>ShipZone fee</b></h6>
          </td>
          <td class="price-section1">
            <h6>${{ detailData.kreenex_fee }}</h6>
          </td>
        </tr>
        <tr v-if="detailData.insurance != null">
          <td class="price-section">
            <h6><b>Insurance</b></h6>
          </td>
          <td class="price-section1">
            <h6>${{ detailData.insurance }}</h6>
          </td>
        </tr>
        <tr v-if="detailData.repackage_price">
          <td class="price-section">
            <h6><b>Repackage Price</b></h6>
          </td>
          <td class="price-section1">
            <h6>${{ detailData.repackage_price }}</h6>
          </td>
        </tr>
        <tr v-if="detailData.hold_price">
          <td class="price-section">
            <h6><b>Hold Price</b></h6>
          </td>
          <td class="price-section1">
            <h6>${{ detailData.hold_price }}</h6>
          </td>
        </tr>
        <tr v-if="detailData.other_service_price">
          <td class="price-section">
            <h6><b>Other Service Price</b></h6>
          </td>
          <td class="price-section1">
            <h6>${{ detailData.other_service_price }}</h6>
          </td>
        </tr>
        <tr v-if="detailData.handling_fee">
          <td class="price-section">
            <h6><b>Handling Fee</b></h6>
          </td>
          <td class="price-section1">
            <h6>${{ detailData.handling_fee }}</h6>
          </td>
        </tr>
        <tr v-if="detailData.discount != null">
          <td class="price-section">
            <h6><b>Discount</b></h6>
          </td>
          <td class="price-section1">
            <h6>${{ detailData.discount }}</h6>
          </td>
        </tr>
        <tr v-if="detailData.total_amount != null">
          <td class="price-section">
            <h6><b>Total Price</b></h6>
          </td>
          <td class="price-section1">
            <h6>${{ detailData.total_amount }}</h6>
          </td>
        </tr>
      </table>
    </div>

    <v-dialog
      v-model="imageDialog"
      width="500"
    >
      <v-card>
        <img
          :src="theImg && theImg.startsWith('http') ? theImg : `${$_image_path()}${theImg}`"
          alt=""
          width="100%"
        >
      </v-card>
    </v-dialog>

    <customer-cancel-order
      :closeCancelingOrderModal="closeCancelingOrderModal"
      :cancelOrderModal="cancelOrderModal"
      :cancelAlert="cancelAlert"
      :cancelData="cancelData"
      :cancelingOrder="cancelingOrder"
    ></customer-cancel-order>

    <approve-order
      :orderId="theOrderId"
      :approveDialog="approveDialog"
      @close="approveDialog = false"
      @resetTable="getOrderDetail()"
    />
  </div>
</template>

<script>
import axios from 'axios'
import swal from 'sweetalert'
import approveOrder from './approveOrder.vue'
import customerCancelOrder from './customerCancelOrder'

export default {
  components: {
    approveOrder,
    customerCancelOrder
  },

  created() {
    this.getLoggedInUser()
    if (
      window.location.search.replace('?id=', '') !== null ||
      window.location.search.replace('?id=', '') !== ''
    ) {
      this.theOrderId = Number(window.location.search.replace('?id=', ''))
      this.getOrderDetail()
    }
  },

  mounted() {
    if (!this.loggedInUserData.is_staff) {
      this.getUser()
    }
  },

  data() {
    return {
      theOrderId: '',
      approveDialog: false,
      orderDetailUrl: 'api/customer_order_detail',
      cancelingOrderUrl: 'api/canceling_order',
      detailResults: [],
      cancelAlert: false,
      cancelOrderModal: false,
      cancelData: {
        cancel_reason: ''
      },
      loggedInUserData: {},
      currentStep: 0,
      isCanceled: false,
      isRefunded: false,
      notfound: false,
      imageDialog: false,
      theImg: '',
      detailData: {}
    }
  },

  methods: {
    closeCancelingOrderModal() {
      this.cancelOrderModal = false
      this.cancelAlert = false
      this.cancelData.cancel_reason = ''
    },

    cancelingOrder() {
      let token = localStorage.getItem('access_token')
      axios
        .put('api/canceling_order/' + this.theOrderId, this.cancelData, {
          headers: { Authorization: 'Bearer ' + token }
        })
        .then(() => {
          this.getOrderDetail()
          this.cancelAlert = true
          setTimeout(() => {
            this.closeCancelingOrderModal()
          }, 1500)
        }).catch(error => {
          if (error.response) {
            swal('Error', `${error.response.data.message}`, 'error')
          }
        })
    },

    requestDelivery() {
      swal({
        title: 'نرخی گەیاندن بۆ کاڵای ئاسایی بۆ ناو هەولێر ٥٠٠٠ دینار، بۆ دەرەوەی هەولێر ١٠٠٠٠ دینار',
        buttons: true,
        className: 'swal-title-1'
      }).then(canceled => {
        if (canceled) {
          let token = localStorage.getItem('access_token')
          let data = {
            order_id_fk: this.theOrderId
          }

          axios.post('api/order-delivery', data, {
            headers: { Authorization: 'Bearer ' + token }
          }).then(response => {
            this.getOrderDetail()
            swal({
              title: 'Done',
              icon: 'success',
              timer: 1500,
              buttons: false
            })
          }).catch(error => {
            if (error.response) {
              swal('Error', `${error.response.data.message}`, 'error')
            }
          })
        }
      })
    },

    showImage(img, mainImage = false) {
      this.theImg = mainImage ? img : img.order_image
      this.imageDialog = true
    },

    getLoggedInUser() {
      this.loggedInUserData = JSON.parse(localStorage.getItem('user_data'))
    },

    getUser() {
      let token = localStorage.getItem('access_token')
      axios.get('api/me', { headers: { Authorization: 'Bearer ' + token } }).then(response => {
        localStorage.setItem('user_data', JSON.stringify(response.data))
      })
    },

    getOrderDetail() {
      let token = localStorage.getItem('access_token')
      axios
        .get(this.orderDetailUrl + '/' + this.theOrderId, {
          headers: { Authorization: 'Bearer ' + token }
        })
        .then(response => {
          let data = response.data
          this.detailResults = data.data

          this.detailData = this.detailResults[0]
          this.$nextTick(() => {
            this.getCurrentStep()
          })
        })
        .catch(error => {
          if (error.response && error.response.data.code_status === 404) {
            this.notfound = true
          }
        })
    },

    getCurrentStep(step = this.detailData.status) {
      if (step === 'new_order') {
        this.currentStep = 0
      } else if (
        step === 'canceled' &&
        (this.detailData.item_price == null || this.detailData.item_price === '')
      ) {
        this.currentStep = 1
        this.isCanceled = true
      } else if (step === 'processed_order') {
        this.currentStep = 2
      } else if (
        step === 'canceled' &&
        (this.detailData.item_price != null || this.detailData.item_price !== '')
      ) {
        this.currentStep = 3
        this.isCanceled = true
      } else if (step === 'approved_order') {
        this.currentStep = 4
      } else if (step === 'refunded') {
        this.currentStep = 5
        this.isRefunded = true
      } else if (step === 'purchased') {
        this.currentStep = 6
      } else if (step === 'warehouse_delivered_order' || step === 'pending_to_shipment') {
        this.currentStep = 7
      } else if (step === 'int_shipment') {
        this.currentStep = 8
      } else if (step === 'pending_to_branch') {
        this.currentStep = 9
      } else if (step === 'branch_delivery') {
        this.currentStep = 10
      } else if (step === 'delivered') {
        this.currentStep = 11
      } else {
        this.currentStep = 0 // Default to first step if status doesn't match
      }
    },

    approvingOrder(id) {
      this.theOrderId = id
      this.approveDialog = true
    }
  }
}
</script>

<style scoped>
.thumbnail {
  width: 100px;
  height: 100px;
  object-fit: cover;
  border-radius: 4px;
}

a.disabled {
  pointer-events: none;
  color: gray;
}

.price-section {
  border-style: solid;
  border-width: 1px;
  width: 230px;
  padding-left: 10px;
}

.price-section1 {
  border-right-style: solid;
  border-bottom-style: solid;
  border-top-style: solid;
  border-width: 1px;
  width: 670px;
  padding-left: 10px;
}

#detailTable {
  width: 700px;
  margin-left: 200px;
  margin-top: 20px;
  margin-bottom: 40px;
}

a:hover {
  color: #03a9f4;
  position: relative;
}
a[tooltip]:hover:after {
  content: attr(tooltip);
  padding: 8px 12px;
  color: #ffffff;
  position: absolute;
  right: 80%;
  bottom: 150%;
  white-space: nowrap;
  z-index: 20;
  -moz-border-radius: 3px;
  -webkit-border-radius: 3px;
  border-radius: 3px;
  -moz-box-shadow: 0px 0px 2px #484b4e;
  -webkit-box-shadow: 0px 0px 2px #484b4e;
  box-shadow: 0px 0px 2px #484b4e;
  background-image: -moz-linear-gradient(top, #484b4e, #484b4e);
  background-image: -webkit-gradient(
    linear,
    left top,
    left bottom,
    color-stop(0, #484b4e),
    color-stop(1, #484b4e)
  );
  background-image: -webkit-linear-gradient(top, #484b4e, #484b4e);
  background-image: -moz-linear-gradient(top, #484b4e, #484b4e);
  background-image: -ms-linear-gradient(top, #484b4e, #484b4e);
  background-image: -o-linear-gradient(top, #484b4e, #484b4e);
}

/* Updated styles for the stepper */
.theStepper {
  width: 100%;
  overflow: visible;
  margin-bottom: 20px;
}

.custom-stepper {
  width: 100%;
  display: block !important;
}

.v-stepper__header {
  box-shadow: none;
}

.v-stepper__step {
  padding: 24px;
}

.v-divider {
  margin: 0;
}

@media screen and (max-width: 1025px) {
  #detailTable {
    margin-left: 0px;
    width: 100%;
  }
  .price-section1 {
    width: 40%;
  }
  .price-section {
    width: 21%;
  }
  .theStepper {
    width: 100%;
    overflow-x: auto;
    overflow-y: hidden;
    margin-bottom: 15px;
  }

  .custom-stepper {
    min-width: 800px;
  }

  .v-stepper__step {
    padding: 12px;
  }

  .divider {
    display: block;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/customer/orderDetail.vue